import { render, staticRenderFns } from "./baseData.vue?vue&type=template&id=6bb7f0a9&scoped=true"
import script from "./baseData.vue?vue&type=script&lang=js"
export * from "./baseData.vue?vue&type=script&lang=js"
import style0 from "./baseData.vue?vue&type=style&index=0&id=6bb7f0a9&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bb7f0a9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre预发布-anjun-express-web-management/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6bb7f0a9')) {
      api.createRecord('6bb7f0a9', component.options)
    } else {
      api.reload('6bb7f0a9', component.options)
    }
    module.hot.accept("./baseData.vue?vue&type=template&id=6bb7f0a9&scoped=true", function () {
      api.rerender('6bb7f0a9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/transfer/base/components/form/steps/baseData.vue"
export default component.exports